import React from 'react';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../baseClasses/BaseComponent';
import aoLogo from '../../assets/images/ao-logo.png';
import dataModel from '../../models/DataModel';

import './ForgotPassword.scss';
import Input from '../../components/Input';

export class ForgotPassword extends BaseComponent {

  constructor(props) {
    super(props);
    this.state = { 
      email: '', 
      emailFocus: false,
      invalidEmailMessage: '',
      emailSent: false,
    };
    delete localStorage.token;

    this.focusEmail = this.focusEmail.bind(this);
    this.blurEmail = this.blurEmail.bind(this);
  }
  
  handleEmailChange(event) {
    this.setState({ 
      email: event.target.value,
    });
    if (this.state.emailFocus != true){
      this.setState({ emailFocus: true });
    }
    if (this.state.emailSent != false){
      this.setState({ emailSent: false });
    }
  }

  handleKeyDown(event) {
    if (event.keyCode == 13) {
      this.handleSendEmail();
    }
  }
  
  handleSendEmail(){
    if(this.state.email != ''){
      if(this.validateEmail(this.state.email)){
        dataModel.usersDAO.sendForgotPassword(this.state.email);
        this.setState({
          emailSent: true,
          emailFocus: false,
        });
        document.getElementById('email').value = '';
      }
    }
  }

  focusEmail(){
    this.setState({ emailFocus: true, invalidEmailMessage: '', emailSent: false });
  }

  blurEmail(){
    if(this.state.email){

    }else{
      this.setState({ emailFocus: false });
    }
  }

  validateEmail(email) {  
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      return true;
    } else {
      this.setState({ invalidEmailMessage: 'Please enter a valid email. "' + this.state.email + '" is not valid.' });
      return false;     
    }
  } 

  handleGoBack() {
    this.props.history.replace('/login');
  }

  render() {
    let displayMessage = null;
    if (this.state.invalidEmailMessage) {
      displayMessage = <div className="forgot-password-message error">
        {this.state.invalidEmailMessage}
      </div>;
      setTimeout(() => {
        this.setState({
          invalidEmailMessage: '',
        });
      },4000);
    }

    if (this.state.emailSent) {
      setTimeout(() => {
        this.setState({
          emailSent: false,
          email: '',
        });
      },4000);
      displayMessage = <div className="forgot-password-message success">
        Thank you! Make sure to check {this.state.email} for instructions on resetting your password. 
      </div>;
    }

    return (
      <div className="forgot-password-background">
        <section className="forgot-password-form">
          <img className="forgot-password-logo" src={aoLogo} alt="logo"/>
          <div className="enter-email-container">
            <div className="enter-email-text">Please enter the email associated with your account to receive an email containing instructions on how to reset your password.</div>
          </div>
          <div className={this.state.emailFocus ? 'forgot-password-email mat-div is-active is-completed' : 'forgot-password-email mat-div'}>
            <label className="forgot-password-label mat-label" htmlFor="email">{this.state.emailFocus ? 'EMAIL' : 'ENTER YOUR EMAIL'}</label>
            <Input className="forgot-password-input mat-input" id="email" onKeyDown={this.handleKeyDown}
              onFocus={this.focusEmail} onBlur={this.blurEmail} onChange={this.handleEmailChange} />
          </div>
          <div className="forgot-password-message-container">
            {displayMessage}
          </div>
          <button className={this.state.email && !this.state.invalidEmailMessage && !this.state.emailSent ? 'forgot-password-button blue-btn' : 'forgot-password-button white-btn'} onClick={this.handleSendEmail}> Send Email </button>
          <div className="forgot-password-goback" onClick={this.handleGoBack}>GO BACK</div>
        </section>
      </div>
    );
  }
}

// Change to appropriate class name
;

export default withRouter(ForgotPassword);



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword/index.js